import { setupUserActivityChecking } from "meta/features/user-activity";
export const useUserActivity = () => {
    const inititalize = () => {
        setupUserActivityChecking(window);
    };
    return { inititalize };
};
